import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from "react-redux";

const KeywordField = ({ data, setData }) => {

    const menuRef = useRef();
    const [suggestions, setSuggestions] = useState([]);
    const [filteredCategories, setFilteredCategories] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const { keywords, categories } = useSelector((state) => state.keywords);

    useEffect(() => {
        document.addEventListener("click", handleClick);
        return () => document.removeEventListener("click", handleClick);
    }, []);

    useEffect(() => {
        document.addEventListener("keydown", handleEscapeBtn);
        return () => document.removeEventListener("keydown", handleEscapeBtn);
    }, []);

    const handleClick = (e) => {
        if (menuRef.current.contains(e.target)) {
            // do nothing
        } else {
            setSuggestions([]);
        }
    };

    const handleEscapeBtn = (e) => {
        if (e.key === "Escape") {
            setSuggestions([]);
        }
    };

    const onTextChanged = (e) => {
        const value = e.target.value;
        let suggestions = [];
        if (value.length > 0) {
            const regex = new RegExp(`^${value}`, "i");
            const keywordss = [...keywords];
            suggestions = keywordss.sort().filter((v) => regex.test(v));
        }

        const filterCategories = suggestions?.filter(function (item) {
            // if(categories) {
                return categories?.some(function (cat) {
                    if (item.length === cat.name.length) {
                        return item === cat.name;
                    }
                });
            // }
        });

        const sortByLength = suggestions.sort(function (a, b) {
            return a.length - b.length;
        });
        const newArr = [...filterCategories, ...sortByLength];

        setFilteredCategories(filterCategories);
        setFilteredData([...new Set(newArr)]);
        setSuggestions(suggestions);
        setData((data) => ({ ...data, ["q"]: value }));
    };

    // const onFocus = () => {
    //     setSearchDropDownOpen(false);
    //     setOpen(false);
    // };

    const suggestionSelected = (item) => {
        setData((data) => ({ ...data, ["q"]: item }));
        setSuggestions([]);
        setFilteredData([]);
    };

    const isCategory = (title) => {
        const isCategory = filteredCategories.some((item) => {
            return item === title;
        });
        return isCategory;
    };

    return (
        <div
            className="main-search-input-item autocomplete-container"
            ref={menuRef}
        >
            <label>
                <i className="fas fa-search"></i>
            </label>
            <input
                id="keywords"
                type="text"
                placeholder="What are you looking for?"
                value={data.q}
                autoComplete="off"
                onChange={onTextChanged}
            //    onFocus={onFocus}
            />
            <ul className={suggestions.length > 0 ? "d-block" : "d-none"}>
                {filteredData.slice(0, 10).map((item, index) => (
                    <li
                        key={index}
                        onClick={() => suggestionSelected(item)}
                        style={{ color: isCategory(item) ? "blue" : "black" }}
                    >
                        {item}
                    </li>
                ))}
            </ul>
        </div>   
    );
};

export default KeywordField;